import { Monitor, Smartphone } from "lucide-react";
import { Slider } from "@/components/ui/slider";

// 9:16 window over a 16:9 player, as a % of the player width.
const BOX = (9 / 16) / (16 / 9) * 100;

export function CropOverlay({ cropX }) {
  const left = cropX * (100 - BOX);
  return (
    <div data-testid="clip-crop-overlay" className="pointer-events-none absolute inset-0">
      <div className="absolute inset-y-0 left-0 bg-black/60" style={{ width: `${left}%` }} />
      <div className="absolute inset-y-0 border-2 border-amber-400 shadow-[0_0_0_1px_rgba(0,0,0,0.6)]" style={{ left: `${left}%`, width: `${BOX}%` }} />
      <div className="absolute inset-y-0 right-0 bg-black/60" style={{ width: `${100 - left - BOX}%` }} />
    </div>
  );
}

export function ClipFormat({ format, setFormat, cropX, setCropX }) {
  const opt = (v, label, Icon) => (
    <button type="button" data-testid={`clip-format-${v}`} onClick={() => setFormat(v)}
      className={"px-3 py-1.5 rounded-lg text-xs font-medium border inline-flex items-center gap-1.5 transition-colors " + (format === v ? "border-amber-500 bg-amber-500/10 text-amber-300" : "border-gray-800 text-gray-400 hover:text-white")}>
      <Icon className="h-3.5 w-3.5" /> {label}
    </button>
  );
  return (
    <div className="space-y-2" data-testid="clip-format">
      <div className="flex items-center gap-2 flex-wrap">
        <span className="text-xs text-gray-400 mr-1">Shape</span>
        {opt("wide", "Wide (16:9)", Monitor)}
        {opt("vertical", "Phone (9:16) for Reels, Shorts, TikTok", Smartphone)}
      </div>
      {format === "vertical" && (
        <div className="flex items-center gap-3">
          <span className="text-xs text-gray-400 shrink-0">Slide the frame</span>
          <Slider data-testid="clip-crop-slider" min={0} max={100} step={1} value={[Math.round(cropX * 100)]} onValueChange={([v]) => setCropX(v / 100)} />
          <button type="button" data-testid="clip-crop-center" onClick={() => setCropX(0.5)} className="text-xs text-amber-400 hover:underline shrink-0">Center</button>
        </div>
      )}
    </div>
  );
}
